module.exports = __webpack_public_path__ + "static/media/04.0597a7f8.JPG";